import React, { useState } from 'react';
import { api } from '../api/client';
import { useNavigate } from 'react-router-dom';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.register(email, name, password);
      alert('Registered. Please login.');
      navigate('/login');
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Registration failed';
      alert(msg);
    }
  };

  return <form onSubmit={submit}>
    <h2>Register</h2>
    <input placeholder='Name' value={name} onChange={e => setName(e.target.value)} />
    <input placeholder='Email' value={email} onChange={e => setEmail(e.target.value)} />
    <input placeholder='Password' type='password' value={password} onChange={e => setPassword(e.target.value)} />
    <button type='submit'>Create Account</button>
  </form>;
};
export default Register;
